export function timeAgo(iso) {
  if (!iso) return '—'
  const s = Math.floor((Date.now() - new Date(iso)) / 1000)
  if (isNaN(s))  return '—'
  if (s < 60)    return `${s}s ago`
  if (s < 3600)  return `${Math.floor(s / 60)}m ago`
  if (s < 86400) return `${Math.floor(s / 3600)}h ago`
  return `${Math.floor(s / 86400)}d ago`
}

export function fmtDate(iso) {
  return new Date(iso).toLocaleDateString('en-IN', {
    month: 'short', day: 'numeric', hour: '2-digit', minute: '2-digit',
  })
}

export function fmtCurrency(n) {
  return '$' + parseFloat(n).toFixed(2)
}

export function stockColor(s) {
  return s === 0 ? 'var(--red)' : s <= 5 ? 'var(--amber)' : 'var(--green)'
}
export function stockLabel(s) {
  return s === 0 ? 'Out of stock' : s <= 5 ? 'Low stock' : 'In stock'
}
export function stockBadge(s) {
  return s === 0 ? 'badge-red' : s <= 5 ? 'badge-amber' : 'badge-green'
}
export function statusBadge(s) {
  return { pending: 'badge-amber', processing: 'badge-blue', shipped: 'badge-purple', completed: 'badge-green', cancelled: 'badge-red' }[s] || 'badge-gray'
}
